import api from '../index';

export const GetAllSubadmin = () => api.get('Admin/Get-All-Sub-Admin');
export const AddSubadmin = (data) => api.post('Admin/Add-Sub-Admin', data);
export const GetSubadminsAndPermissionApi = (userId) => api.get(`RolesAndPermission/GetModulesPermissionByUserId/${userId}`);
export const updatePermissionBysubadmin = (data) => api.post('RolesAndPermission/Update-Module-Permission-For-User', data);
export const DeactiveUser = (data) => api.put('Admin/Active-DeactiveUser', data);
export const DeleteSubadmin = (userId) => api.delete(`Admin/Delete-Sub-Admin/${userId}`);
export const ChangePasswordApi = (data) => api.put('Admin/Change-Password', data);
export const AssignTicketToSubAdmin = (data) => api.post('Admin/Assign-Ticket-To-Sub-Admin', data);
